import * as React from 'react';

// tslint:disable:max-line-length
export const SecureIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
    <path
      fillRule="nonzero"
      d="M15 3.001c-1.75 0-4.545-1.408-6.4-2.8a.996.996 0 0 0-1.2 0c-1.855 1.392-4.65 2.8-6.4 2.8a1 1 0 0 0-1 1c0 5.584 2.701 9.817 7.606 11.919a1 1 0 0 0 .788 0C13.299 13.818 16 9.585 16 4.001a1 1 0 0 0-1-1zM8 13.905V8.001H2.616a12.037 12.037 0 0 1-.589-3.093C3.955 4.583 6.236 3.446 8 2.231v5.77h5.384c-.878 2.634-2.69 4.643-5.384 5.904z"
    />
  </svg>
);
